var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.itemsPerPage || 10},scopedSlots:_vm._u([{key:"item.ID",fn:function( ref){
var item = ref.item;
return [_c('span',[_c('router-link',{attrs:{"to":{ name: _vm.pathName(item.vo) , params: { id: item.ID } }}},[_vm._v(" "+_vm._s(item.ID)+" ")])],1)]}},{key:"item.RowStatus",fn:function( ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.getRowStatus( item.RowStatus ))+" ")])]}},{key:"item.TypeID",fn:function( ref){
var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.typeID(item.TypeID))+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }